import React from 'react'
// import { AiOutlineDownload } from 'react-icons/ai'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
// import pdfFile from '../../public/Fuad-Nasser-Aldeen-Cv.pdf' // Update the path to your PDF file
import 'react-pdf/dist/esm/Page/TextLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

function Resume() {
    const pdf = 'cv.pdf'
    return (
        <section id="resume" className="resume">
            <span className="heading-title u-margin-left-medium u-margin-top-small">Resume</span>
            <button className="dawnload__button">
                <span className="dawnload__button_lg">
                    <a className='btn' href={pdf} target='_blank'>
                        <span className="dawnload__button_sl"></span>
                        <span className="dawnload__button_text">Download Resume</span>
                    </a>

                </span>
            </button>
            <div className="resume-section" >
                
                {/* <button className="cssbuttons-io-button">
                    <a className='btn flex items-center' href={pdf} target='_blank'>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path fill="currentColor" d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013zM13 12h3l-4 5-4-5h3V8h2v4z"></path>
                        </svg>
                        <span>Download Resume</span>
                    </a>
                </button> */}

                {/*                 
                <div className="resume-button">
                    <a className='btn flex items-center' href={pdf} target='_blank'>
                        <AiOutlineDownload />
                        {' '}Download Resume
                    </a>
                </div> */}
                <div className='pdf-container'>
                    <Document file={pdf}>
                        <Page pageNumber={1} scale={window.innerWidth > 786 ? 1.7 : 0.6} />
                    </Document>
                </div>
            </div>
        </section>

    )
}

export default Resume
